/**
 * @generated SignedSource<<72f342353e664f9dac83710611648340>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type WorkatoIntegration = "HiBob" | "%future added value";
export type StopRecipesInput = {
  integration?: WorkatoIntegration | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type stopRecipesMutation$variables = {
  input: StopRecipesInput;
};
export type stopRecipesMutation$data = {
  readonly stopRecipes: {
    readonly outcome: string | null;
  } | null;
};
export type stopRecipesMutation = {
  variables: stopRecipesMutation$variables;
  response: stopRecipesMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "StopRecipesPayload",
    "kind": "LinkedField",
    "name": "stopRecipes",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "outcome",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "stopRecipesMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "stopRecipesMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "42db0ec2b77688d2e520f675cc574035",
    "id": null,
    "metadata": {},
    "name": "stopRecipesMutation",
    "operationKind": "mutation",
    "text": "mutation stopRecipesMutation(\n  $input: StopRecipesInput!\n) {\n  stopRecipes(input: $input) {\n    outcome\n  }\n}\n"
  }
};
})();

(node as any).hash = "7d0b170724681343bb6d4ac9e0ee3426";

export default node;
